import { render } from "./QuestionForm.vue?vue&type=template&id=152fb462&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionForm.vue?vue&type=script&setup=true&lang=js"

import "./QuestionForm.vue?vue&type=style&index=0&id=152fb462&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152fb462"],['__file',"resources/js/modules/learning_module/components/question/QuestionForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "152fb462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('152fb462', __exports__)) {
    api.reload('152fb462', __exports__)
  }
  
  module.hot.accept("./QuestionForm.vue?vue&type=template&id=152fb462&scoped=true", () => {
    api.rerender('152fb462', render)
  })

}


export default __exports__